import messagesData from '@/data/messages.json';

export type MessageEntry = {
  slot: number;
  text: string;
  active: boolean;
};

const allMessages: MessageEntry[] = (messagesData as MessageEntry[])
  .filter((entry) => entry && typeof entry.slot === 'number' && typeof entry.text === 'string')
  .map((entry) => ({
    slot: entry.slot,
    text: entry.text,
    active: Boolean(entry.active),
  }))
  .sort((a, b) => a.slot - b.slot);

const activeMessages = allMessages.filter((entry) => entry.active);
const messageBySlot = new Map<number, MessageEntry>(allMessages.map((entry) => [entry.slot, entry]));

export function getAllMessageSlots(): MessageEntry[] {
  return allMessages;
}

export function getActiveMessageSlots(): MessageEntry[] {
  return activeMessages;
}

export function getMessageSlotCount(): number {
  const last = allMessages[allMessages.length - 1];
  return last ? last.slot + 1 : 0;
}

export function getMessageText(slot: number): string {
  return messageBySlot.get(slot)?.text ?? '';
}

export function getRandomMessage(): string {
  if (!activeMessages.length) return '';
  return activeMessages[Math.floor(Math.random() * activeMessages.length)].text;
}
